<template>
  <component v-if="slider" :is="slider">
    <div v-if="showOffer"><OfferCard /></div>

    <CardSelector
      v-for="marketIds in orderedMarkets"
      :key="marketIds[0]"
      :marketIds="marketIds"
    />
  </component>
  <OfferCard v-else-if="showOffer" />
  <CardSelector v-else></CardSelector>
</template>

<script lang="ts">
import CardSelector from "./CardSelector.vue";
import { computed, defineAsyncComponent, defineComponent, provide } from "vue";
import { useDisplayEvents } from "../hooks/useDisplayingEvents";
import { isTouchDevice } from "../lib/isTouchDevice";
import OfferCard from "./Offer.vue";
import { injectOffer } from "../composition/offer";

export default defineComponent({
  name: "Content",
  components: {
    CardSelector,
    OfferCard
  },
  setup() {
    const { orderedMarkets } = useDisplayEvents();
    const isTouch = isTouchDevice();
    const { showOffer } = injectOffer();

    provide("carouselContext", true);

    const slider = computed(() => {
      if (
        orderedMarkets.value.length > 1 ||
        (showOffer.value && orderedMarkets.value.length)
      ) {
        if (isTouch) {
          return defineAsyncComponent(() => import("./TouchSlider"));
        }
        return defineAsyncComponent(() => import("./Carousel"));
      }
      return false;
    });

    return {
      showOffer,
      slider,
      orderedMarkets
    };
  }
});
</script>
